import useAuthContext from '@salesforce/commerce-sdk-react/hooks/useAuthContext';
import { useQuery } from '@tanstack/react-query';
import { useDebounceValue } from 'usehooks-ts';
import type { UseQueryResult } from '@tanstack/react-query';
import { useCustomPreferenceOrDefault } from '../../utils/api';
import { CustomPreference } from '../../utils/api/CustomPreference';
import { isServer } from '../../utils/utils';
import { bffGet } from '../bff';
import { BffQueryKey } from '../model/BffQueryKey';
import type { DeliveryResponse } from './model';

export const useEstimatedDeliveryDate = (zipCode = ''): UseQueryResult<DeliveryResponse> => {
    const authContext = useAuthContext();
    const eddEnable = useCustomPreferenceOrDefault(CustomPreference.EDD_ENABLE, true);
    const [debouncedZipCode] = useDebounceValue(zipCode, 300);

    return useQuery<DeliveryResponse, unknown>({
        queryFn: async () => {
            if (!isServer) await window.sfccSessionCreationPromise;
            const authData = await authContext.ready();
            return bffGet<DeliveryResponse>('/delivery/estimated-delivery-date', {
                httpParams: [{ zipCode: debouncedZipCode }],
                accessToken: authData.access_token,
                customerId: authData.customer_id,
            });
        },
        queryKey: [BffQueryKey.EDD, debouncedZipCode],
        enabled: !!(eddEnable && debouncedZipCode),
        staleTime: Infinity,
    });
};
